import { styled } from '@mui/material/styles';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

const styledIcon = IconComponent =>
    styled(IconComponent)({
        width: 18,
        height: 18,
        marginRight: 8,
        color: 'var(--text-secondary)',
        '& path': {
            fill: 'var(--text-secondary)',
        },
    });

export const StyledSaveIcon = styledIcon(SaveRoundedIcon);
export const StyledDeleteIcon = styledIcon(DeleteRoundedIcon);
